var MDB = window.MDB || {};
MDB.Support = MDB.Support || {};

$.extend(MDB.Support, {
    bootTicketEditor: function(config){
        var attachmentContainer =  $('.attachment-container'), 
        attachmentUploadContainer = $('.attachment-upload-container'), 
        followersBox = $('#follower-selectbox'),
        projectSelect = $('#ProjectKey'),
        issueContainer = $('#issue-container'),
        issueSelect = issueContainer.find('select');

        var issueTypes = JSON.parse(config.issueTypes);

        loadIssueTypes(projectSelect.val());

        followersBox.kendoMultiSelect({
            autoClose: false,
            filter: 'contains'
        });

        attachmentContainer.on('click', '.remove-upload', function(){
            $(this).parent().remove();
        });

        attachmentContainer.on('click', '.add-upload', function(){
            MDB.Support.addAttachmentUpload(attachmentUploadContainer,  config.uploadElementName);
        });

        projectSelect.change(function(e) {
            loadIssueTypes(e.target.value);
        });

        MDB.Support.addAttachmentUpload(attachmentUploadContainer, config.uploadElementName, true);

        function loadIssueTypes(project) {
            //We'll need the placeholder for the new source.
            var defaultValue = issueSelect.children().eq(0).clone();
            
            issueSelect.empty(); //Empty list
            issueSelect.append(defaultValue); //Append placeholder
            
            //Append issueTypes of the selected project.
            issueTypes[project].forEach(function (type) {
                issueSelect.append(`<option value="${type.Value}">${type.Text}</option>`);
            });

            //Select the appropriate issuetype (will select placeholder if null)
            issueSelect.val(config.selectedIssue);
            issueContainer.show();
        }
    },
    addAttachmentUpload: function(attachmentContainer, uploadElementName, isFirst){
        var container = $('<div />', {
            class: 'col-xs-12 my-1'
        });
        var addButton    = '<i class="fa fa-plus mr-3 add-upload"></i>';
        var deleteButton = '<i class="fa fa-trash mr-3 remove-upload" />';
        

        var inputElement = $('<input />', {
            type: 'file',
            multiple: 'multiple',
            class: 'd-inline-block',
            name: uploadElementName
        });

        container
            .append(isFirst ? addButton : deleteButton)
            .append(inputElement)
            .appendTo(attachmentContainer);
    }
});
